// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capsuleEntryOuterFlex {
    gap: 10px;
}

.capsuleEntry {
    width: 400px;
}

.capsuleEntryHeader {
    font-size: 14px;
    line-height: 40px;
    border-bottom: 1px solid #D5D5D5;
}

.capsuleEntryRowFlex {
    margin-left: 10px;
}

.capsuleEntryCaption {
    line-height: 40px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/capsulecontent/capsule.content.settings.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".capsuleEntryOuterFlex {\n    gap: 10px;\n}\n\n.capsuleEntry {\n    width: 400px;\n}\n\n.capsuleEntryHeader {\n    font-size: 14px;\n    line-height: 40px;\n    border-bottom: 1px solid #D5D5D5;\n}\n\n.capsuleEntryRowFlex {\n    margin-left: 10px;\n}\n\n.capsuleEntryCaption {\n    line-height: 40px;\n    font-size: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
